import { GetLegacyTimelineSummaryRequest } from './getLegacyTimelineSummary';
import { LegacyTimelineTableEntry } from '@types';
import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';
import { OffsetPaginatedResource, OffsetPaginationParams } from '@sonar-software/sonar-ts-types';

export type GetLegacyTimelineDetailsRequest = GetLegacyTimelineSummaryRequest & OffsetPaginationParams;

export type GetLegacyTimelineDetailsResponse = OffsetPaginatedResource<LegacyTimelineTableEntry>;

export const getLegacyTimelineDetails = createGetEndpoint<
	GetLegacyTimelineDetailsRequest,
	GetLegacyTimelineDetailsResponse
>(
	(request) => `/api/v2/Timelines/details?${getQueryString(request)}`
);
